import { render } from "./Request.vue?vue&type=template&id=0a93b565&scoped=true"
import script from "./Request.vue?vue&type=script&lang=js"
export * from "./Request.vue?vue&type=script&lang=js"

import "./Request.vue?vue&type=style&index=0&id=0a93b565&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a93b565"

export default script